const CSS_VAR_CACHE: Record<string, Record<string, string>> = { default: {} };

// All vars needs to be defined in the CSS and prefixed with `--`
export function getCSSVar(variableName: string, scope = "default") {
  // Check if color is already cached
  if (CSS_VAR_CACHE[variableName]) {
    return CSS_VAR_CACHE[scope][variableName];
  }

  // Get color from CSS variable
  const color = getComputedStyle(document.body)
    .getPropertyValue(variableName)
    .trim();

  // Cache the scoped color
  if (!CSS_VAR_CACHE[scope]) CSS_VAR_CACHE[scope] = {};
  CSS_VAR_CACHE[scope][variableName] = color;

  return color;
}
